"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.start.prompt': 'Rozpocznij szkolenie',
    'tutorial.start.prompt.continued': 'Kontynuuj szkolenie od sekcji {sectionName}'
};
